export default "__VITE_ASSET__DJzjsRKF__"